import React from "react";
import { Box, Typography, createStyles, makeStyles } from "@material-ui/core";
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        callbackImg: {
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
            height: "96px",
            width: "96px",
            borderRadius: "4px",
            backgroundColor: theme.palette.colors.primary[1500],
            color: theme.palette.colors.primary[1400]
        },
        initials: {
            color: theme.palette.colors.primary[1400],
            fontSize: "\"".concat(theme.typography.pxToRem(30), "\""),
            textTransform: "uppercase"
        },
        img: {
            display: "block"
        }
    });
});
export var ProfileAvatar = function (_a) {
    var profilePictureUrl = _a.profilePictureUrl, firstName = _a.firstName, lastName = _a.lastName;
    var classes = useStyles();
    return profilePictureUrl ? (React.createElement("img", { alt: "Profile avatar", src: profilePictureUrl, width: "96", height: "96", className: classes.img })) : (React.createElement(Box, { className: classes.callbackImg },
        React.createElement(Typography, { className: classes.initials }, "".concat(firstName === null || firstName === void 0 ? void 0 : firstName.charAt(0)).concat(lastName === null || lastName === void 0 ? void 0 : lastName.charAt(0)))));
};
//# sourceMappingURL=ProfileAvatar.js.map